<script>
export default {
	name: "contactCard",
	props: {
		contactsList: {
			type: Array,
			required: true
		}
	}
};
</script>

<template>
	<v-row>
		<v-col cols="12">
			<v-card>
				<v-card-title>
					Contacts
				</v-card-title>
				<v-card-text>
					<v-list>
						<v-list-item
							v-for="(contact, index) in contactsList"
							:key="index" three-line
						>
							<v-list-item-content>
								<v-list-item-title>
									{{ contact.firstName }} {{ contact.surName }}
								</v-list-item-title>
								<v-list-item-subtitle>
									<v-icon small>mdi-email</v-icon>
									<a :href="'mailto:' + contact.email">
										{{ contact.email }}
									</a>
								</v-list-item-subtitle>
								<v-list-item-subtitle>
									<v-icon small>mdi-phone</v-icon>
									<a :href="'tel:' + contact.phone">
										{{ contact.phone }}
									</a>
								</v-list-item-subtitle>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-card-text>
			</v-card>
		</v-col>
	</v-row>
</template>

<style scoped>
a {
	text-decoration: none;
	color: inherit;
}
.v-list-item {
	padding: 0;
}
.v-card__title {
	padding-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/layout/ContactCard.vue